const topics = [
  { tag: '暑期档', heat: '9.8万', icon: 'ri-sun-line' },
  { tag: '高分推荐', heat: '8.5万', icon: 'ri-star-line' },
  { tag: '国产剧', heat: '12.3万', icon: 'ri-tv-line' },
  { tag: '美剧', heat: '7.6万', icon: 'ri-global-line' },
  { tag: '韩剧', heat: '6.9万', icon: 'ri-heart-pulse-line' },
  { tag: '动漫', heat: '8.2万', icon: 'ri-camera-3-line' },
  { tag: '综艺', heat: '5.4万', icon: 'ri-mic-line' },
  { tag: '纪录片', heat: '4.1万', icon: 'ri-earth-line' },
  { tag: '经典老片', heat: '6.7万', icon: 'ri-history-line' },
  { tag: '院线新片', heat: '10.1万', icon: 'ri-film-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            大家都在讨论的影视话题，看看什么最热门
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className="group inline-flex items-center gap-2.5 px-5 py-3 bg-background-50 border border-background-200/70 rounded-full hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <i className={`${topic.icon} text-base text-accent-500 group-hover:text-primary-500 transition-colors`}></i>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.tag}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 group-hover:bg-primary-100 px-2 py-0.5 rounded-full transition-colors whitespace-nowrap">
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}